import {
  DetailedHTMLProps,
  FC,
  ReactNode,
  SyntheticEvent,
  ThHTMLAttributes,
  useMemo,
} from 'react';

import classNames from 'classnames';

import './TableHeaderCell.scss';

import { TestMetadata } from '../types';

export interface Props
  extends DetailedHTMLProps<
    ThHTMLAttributes<HTMLTableHeaderCellElement>,
    HTMLTableHeaderCellElement
  > {
  /** Cell's content */
  children?: ReactNode;
  /** Cell's classname */
  className?: string;
  /** Table header tag classname */
  tableHeaderClassName?: string;
  /** Cell's onclick */
  onClick?: (e: SyntheticEvent) => void;
  /** Cell's sortable */
  sortable?: boolean;
  /** Cell's checkbox */
  checkbox?: boolean;
  /** Cell's active */
  active?: boolean;
  //** Sort direction */
  sortDir?: 'asc' | 'desc';
  //** resizable cell  */
  resizable?: boolean;
  // Test IDs for component sections
  testMetadata?: TestMetadata;
}

const TableHeaderCell: FC<Props> = ({
  children,
  className,
  tableHeaderClassName,
  checkbox,
  sortable,
  active,
  sortDir,
  onClick,
  resizable,
  testMetadata,
  ...otherProps
}) => {
  const tableHeaderCellTextClasses = useMemo(
    () =>
      classNames(
        'sb-table-header-cell-text',
        {
          'sb-table-header-cell_sortable': sortable,
          'sb-table-header-cell-checkbox': checkbox,
          'sb-table-header-cell_active': active,
          'sb-table-header-cell_sorted-asc': sortDir === 'asc',
          'sb-table-header-cell_sorted-desc': sortDir === 'desc',
        },
        className,
      ),
    [active, className, sortDir, sortable, checkbox],
  );
  return (
    <th
      {...otherProps}
      className={classNames(
        'sb-table-header-cell',
        { 'sb-table-header-cell_resizable': resizable },
        tableHeaderClassName,
      )}
      onClick={onClick}
      {...testMetadata}
    >
      <div className={tableHeaderCellTextClasses}>{children}</div>
    </th>
  );
};

export default TableHeaderCell;
